import React, {useState} from 'react'

//when the page is loading
function Pending() {
    let [loading, setLoading] = useState('')
    
    setInterval(function(){
        setLoading( loading += '.')
        
    }, 500)
    
  return (
    <div className='App-loading'> Loading {loading}</div>
  )
}

export default Pending